<template>
  <div>
    <app-form-holder>
      <!--  -->
      <app-form-title title="Sign in to E4T">
        Provide your email address and password to sign in!
      </app-form-title>
      <!--  -->
      <!-- Login form -->
      <div>
        <el-form
          v-loading="loading"
          :rules="rules"
          @submit.prevent
          class="App-Styled-Form"
          :label-position="'top'"
          label-width="100px"
          :model="form"
          style="margin-top: 12px"
        >
          <!--  -->
          <!-- Email -->
          <el-form-item prop="email" label="Email">
            <template v-slot:label>
              <el-icon>
                <Message />
              </el-icon>
              Email
            </template>
            <el-input
              placeholder="johndoe@e4t.com"
              v-model="form.email"
            ></el-input>
          </el-form-item>
          <!--  -->
          <!-- Password -->
          <el-form-item prop="password" label="Password">
            <template v-slot:label>
              <el-icon>
                <lock />
              </el-icon>
              Password
            </template>
            <el-input
              placeholder="********"
              type="password"
              v-model="form.password"
              show-password
            />
          </el-form-item>
          <!--  -->
          <div txt-center>
            <el-button
              :disabled="!form.email || !form.password"
              is-block
              size="large"
              type="primary"
              icon="el-icon-right"
              @click="login"
            >
              Sign In
            </el-button>
          </div>
        </el-form>
      </div>
      <!--  -->
      <!--  -->
      <el-divider />
      <!--  -->
      <!-- Other links -->
      <div txt-center>
        <el-space
          w-100
          :fill="true"
          alignment="center"
          direction="vertical"
          :size="4"
        >
          <div>
            <router-link to="/forgot">
              <el-link type="primary">Forgot Password</el-link>
            </router-link>
          </div>
          <div>
            <span>Don't have an account?</span>
          </div>
          <!--  -->
          <app-create-account-links> </app-create-account-links>
          <!--  -->
        </el-space>
      </div>
      <!--  -->
    </app-form-holder>
  </div>
</template>

<script lang="ts">
import { AuthToken, AuthUtil } from "@/@auth/classes";
import { ErrorUtil } from "@/shared";
import { Lock, Message } from "@element-plus/icons";
import { AxiosError, AxiosResponse } from "axios";
import { Options, Vue } from "vue-class-component";
import { LoginResponse } from "../../interfaces";

@Options({
  components: { Message, Lock },
})
export default class extends Vue {
  // Form data
  form = { email: undefined, password: undefined };
  //
  loading = false;
  rules = {
    email: [
      { required: true, message: "Email is required!", trigger: "blur" },
      {
        type: "email",
        message: "Email address is incorrect",
        trigger: ["blur", "change"],
      },
    ],
    password: [
      { required: true, message: "Password is required!", trigger: "blur" },
      {
        min: 8,
        max: 35,
        message: "Length should be 8 to 35 characters",
        trigger: "blur",
      },
    ],
  };
  /**
   * @sends the login request to the API
   */
  login(): void {
    this.loading = true;
    this.$api.main
      .post("/v1/auth/login", this.form)
      .then((resp: AxiosResponse<LoginResponse>) => {
        this.loginFinalize(resp.data);
      })
      .catch((err: AxiosError) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  /**
   * On a successfull login
   * It sets the cookie and then decides where to go
   * @param response
   */
  loginFinalize(response: LoginResponse) {
    AuthToken.setToken(response.token);
    this.redirectUser(response);
  }
  /**
   * Redirects users based on hi/her role
   * @param response
   */
  redirectUser(response: LoginResponse) {
    AuthUtil.redirectUser(response.user);
  }
}
</script>

<style lang="scss"></style>
